<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col>
          <v-breadcrumbs :items="breadcrumbs">
            <template v-slot:divider>
              <v-icon>chevron_right</v-icon>
            </template>
          </v-breadcrumbs>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-tabs v-model="activeTab"
                  background-color="primary"
                  dark>
            <v-tab :to="`/patients/${patientId}`">
              Overview
            </v-tab>
            <v-tab :to="`/patients/${patientId}/edit`">
              Edit
            </v-tab>
            <v-tab :to="`/patients/${patientId}/cases`">
              Cases
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <router-view :patient="patient"></router-view>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex'

export default {
  name: 'Patient',
  props: {
    patientId: String
  },
  data() {
    return {
      activeTab: null
    }
  },
  computed: {
    ...mapState({}),
    ...mapGetters({
      patientsById: 'patients/patientsById'
    }),
    breadcrumbs() {
      let currentRouteName = this.$router.currentRoute.name
      const patient = this.patientsById[this.patientId]
      return [
        {
          text: 'Patients',
          disabled: false,
          href: '#/patients'
        },
        {
          text: patient.name,
          disabled: true,
        }
      ]
    },
    patient() {
      return this.patientsById[this.patientId] || null
    }
  }
}
</script>

<style scoped>

</style>